export default "__VITE_ASSET__bXmDquln__"